import { Box, BoxProps } from '@mui/material';

export default function IssueTimelineChangesContainer({
  children,
  ...props
}: BoxProps) {
  return (
    <Box pl={5 / 2} {...props}>
      {children}
    </Box>
  );
}
